<template>
  <v-container fluid class="project-page text-left px-0 py-0" v-if="!!project.body">
    <v-layout row wrap>
      <v-flex xs12 md6 hidden-md-and-up>
        <!-- <div class="fullScreen"> -->
        <!-- <video-bg
            v-if="project.youtube && project.youtubeFeatured"
            :youtubeId="project.youtube"
        ></video-bg>-->
        <v-img class="px-0 elevation-10" :src="project.imageFeatured"></v-img>
        <!-- </div> -->
      </v-flex>

      <v-flex
        md6
        offset-sm0
        xs12
        class="pt-5 px-4 p-rel"
        :class="{'scroll': $vuetify.breakpoint.mdAndUp}"
      >
        <v-card flat color="transparent">
          <v-card-title primary-title>
            <h2 class="mb-0">
              {{project.title}}
              <v-dialog v-model="dialog" v-if="!!project.youtube">
                <template v-slot:activator="{ on }">
                  <v-btn
                    target="_blank"
                    v-on="on"
                    large
                    class="primary--text youtube-button"
                    title="Youtube Link"
                    flat
                  >
                    <v-icon size="24px">fab fa-youtube</v-icon>
                  </v-btn>
                </template>
                <iframe
                  class="yt-iframe"
                  align="middle"
                  :src="`https://www.youtube.com/embed/${project.youtube}`"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </v-dialog>
            </h2>

            <h3 class="mb-4 mt-3 mr-3 project-types d-inline-block">
              <v-btn flat v-if="project.projectType === 'idea'" to="/experiments?type=0">💡 idea</v-btn>
              <v-btn
                flat
                v-if="project.projectType === 'prototype'"
                to="/experiments?type=1"
              >💎 prototype</v-btn>
              <v-btn flat v-if="project.projectType === 'pilot'" to="/experiments?type=2">🚀 pilot</v-btn>
            </h3>

            <span v-if="!!project.projectThemes" class="mb-4">
              <v-btn
                v-for="theme in project.projectThemes"
                :key="theme"
                :to="'/experiments?themes=' + theme"
                color="grey lighten-2"
                class="ml-0 rounded project-themes"
                label
                chip
                small
              >{{ theme }}</v-btn>
            </span>

            <p v-html="uriDecode(project.body)" class="text-left body-text"></p>

            <!-- <h3 v-if="!!project.contributors.length" class="mt-5 mb-0">Project Contributors</h3> -->

            <!-- <v-container
              v-if="!!project.contributors.length"
              grid-list-md
              class="mb-3 pt-0 mt-0 px-0"
            >
              <v-list two-line dense expand sm6 class="contributor-tile">
                <template>
                  <v-layout row wrap justify-sm-center>
                    <v-flex
                      xs12
                      sm6
                      v-for="contributor in project.contributors"
                      :key="contributor.uri"
                      class="contributor-tile"
                    >
                      <v-list-tile :key="contributor.uri" avatar class="contributor-tile" light>
                        <v-list-tile-avatar>
                          <v-img v-if="!!contributor.imageDisplay" :src="contributor.imageDisplay"></v-img>
                          <span v-if="!contributor.imageDisplay">{{contributor.displayName[0]}}</span>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title>{{contributor.displayName}}</v-list-tile-title>
                          <v-list-tile-sub-title>{{contributor.role}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-flex>
                  </v-layout>
                </template>
              </v-list>
            </v-container> -->
          </v-card-title>

          <v-card-actions class="mb-5">
            <v-badge overlap class="elevation-10 clap-button-container">
              <!-- <template v-slot:badge>
                <span>{{ project.likes == 0 || !project.likes ? 0 : project.likes }}</span>
              </template>-->
              <vue-clap-button
                class="icon clap-button"
                @clap="increase"
                @cancel="cancel"
                ref="clap"
                :maxClick="2"
                colorNormal="#34b233"
                colorActive="#34b233"
              ></vue-clap-button>
            </v-badge>
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex xs12 md6 hidden-sm-and-down>
        <div class="fullScreen" ref="fullscreenSize" id="fullscreenSize">
          <video-bg v-if="project.youtube && project.youtubeFeatured" :youtubeId="project.youtube"></video-bg>
          <v-img
            v-if="!project.youtube || !project.youtubeFeatured"
            class="px-0"
            :src="project.imageFeatured"
          ></v-img>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style lang="scss">
.project-page {
  background: white;
  .youtube-button {
    position: inline !important;
    padding: 0;
    width: auto !important;
    min-width: 40px !important;
  }
  h2 {
    line-height: 1.2em;
    @media only screen and (min-width: 600px) {
      font-size: 4em;
    }
  }
  img {
    height: calc(100vh - 10px) !important;
  }
  .rounded {
    border-radius: 1em;
  }
  .body-text {
    & > * {
      margin-bottom: 0.5em;
    }
  }
  .contributor-tile {
    // background: #FAFAFA;
    background: white;
  }
  .project-types {
    display: inline-block;
    width: auto;
    .v-btn {
      border-bottom: 1px solid black;
      border-radius: 0;
      text-transform: capitalize !important;
    }
  }
  .project-themes {
    text-transform: capitalize !important;
  }
  .fullScreen {
    background: #f2f3f2;
    &:after {
      content: " ";
      position: absolute;
      width: 100%;
      height: 100%;
      background: black;
      opacity: 0;
      z-index: 2;
      top: 0;
      left: 0;
    }
    &#fullscreenSize {
      img {
        height: calc(10vh - 100px) !important;
      }
    }
    @media only screen and (max-width: 960px) {
      height: 450px;
      min-height: 450px;
    }
  }
  .clap-button-container {
    height: 50px;
    border-radius: 50%;
    background: white;
    padding: 0 !important;
    .clap-button {
      margin: 0 !important;
      .vclapbtn-bin,
      .cancel-love {
        border: none !important;
      }
      border: none;
    }
    .yt-iframe {
      height: 300px;
    }
  }
}
</style>

<script>
import Vue from 'vue'
import videoBg from '@/components/videoBg.vue'
import { db, FieldValue } from '@/db.js'
import vueClapButton from 'vue-clap-button'

export default {
  name: 'project',
  components: {
    videoBg
  },
  data () {
    return {
      projectQuery: [],
      uri: this.$route.params.id,
      pageNotFound: false,
      clapCount: 0
    }
  },
  metaInfo () {
    return {
      title: this.project.title,
      meta: [{ vmid: 'description', name: 'description', content: 'bar' }]
    }
  },
  methods: {
    uriDecode: function (message) {
      return decodeURIComponent(message)
    },
    increase () {
      const increment = FieldValue.increment(1)
      this.clapCount++

      db.collection('projects')
        .doc(window.location.pathname.split('/').slice(-1)[0])
        .update({ likes: increment })
        .then(() => {})
        .catch(error => {
          throw new Error(error)
        })
    },
    cancel () {
      const decrement = FieldValue.increment(-this.clapCount)
      let vm = this
      db.collection('projects')
        .doc(window.location.pathname.split('/').slice(-1)[0])
        .update({ likes: decrement })
        .then(() => {
          vm.clapCount = 0
        })
        .catch(error => {
          throw new Error(error)
        })
    },
    navSetTransparent () {
      this.$store.dispatch('navSetTransparent')
    }
  },
  computed: {
    project () {
      const emptyProject = {
        title: 'Loading...',
        body: ''
      }
      const q = this.projectQuery

      if (q !== undefined && !!q.length) {
        return this.projectQuery[0]
      } else {
        return emptyProject
      }
    },
    transparent () {
      return this['$store'].state.navIsTransparent
    }
  },
  mounted () {
    if (window.innerWidth >= 960) {
      this.$store.dispatch('navSetTransparent', true)
      this.$store.dispatch('navSetDark', false)
    }
  },
  beforeDestroy () {
    if (window.innerWidth >= 960) {
      this.$store.dispatch('navSetTransparent', false)
      this.$store.dispatch('navSetDark', true)
    }
  },
  firestore () {
    return {
      projectQuery: db
        .collection('projects')
        .where('uri', '==', window.location.pathname.split('/').slice(-1)[0])
        .limit(1)
    }
  }
}
</script>
